import React, { useState } from "react";
import { useStandard } from "../../../context/StandardContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import ViewTableIndex from "../../../components/View/ViewTableIndex";
import UseGetData from "../../../hooks/useFetchData";
import { AddIcon, DownArrow, PaperClip, UpArrow } from "../../../assets/icons";
import NuDateFormat from "../../../utils/NuDate";
import useGetStatusData from "../../../hooks/useGetStatusData";
import useDashboardStatus from "../../../hooks/useDashboardStatus";
import CreateOrEdit from "./from";
import ViewMore from "./viewMore";
import CommonXlsExport from "../../../utils/CommonXlsExport";
import useGetStandardDetail from "../../../hooks/useGetStandardDetail";
import CommonImport from "../../../utils/CommonImport";
import CommomApproval from "../../../utils/CommomApproval";
import { GetAccess } from "../../../utils/RolesandAccess";
import axiosInstance from "../../../services/axiosComman";
import CreateForm from "./headerFrom";
import useFetchMetaData from "../../../hooks/useFetchMetaData";

function InternalAuditChecklistIndex() {
  const ModelId = 2;
  const { standardName } = useStandard();
  const { stdId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  let { statusFilter } = location?.state || "";
  const { statusValue } = useGetStatusData({ value: ModelId });
  const {
    completePercentage,
    getData: getDashboardData,
    isReveiw,
  } = useDashboardStatus({
    url: `/DashBoard/standard/${stdId}/internal_audit/`,
  });
  const [showMyModal, setShowMyModal] = useState(false);
  const handleOnClose = () => setShowMyModal(false);
  const [showMyMenuModal, setShowMyMenuModal] = useState(false);
  const handleOnCloseMenu = () => setShowMyMenuModal(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [dataCount, setDataCount] = useState(20);
  const { data, totalCount, getData, isLoading } = UseGetData({
    url: statusFilter
      ? `/internal-audit/standard/${stdId}/status/${statusFilter}`
      : `/internal-audit/standard/${stdId}`,
    page: pageIndex,
    pageCount: dataCount,
  });
  const { standardDetailName, standardStartDate, standardEndDate } =
    useGetStandardDetail({ id: stdId });
  const [showExport, setShowExport] = useState(false);
  const [showImport, setShowImport] = useState(false);
  const [selected, setSelected] = useState(null);
  const [expandedRow, setexpandedRow] = useState([]);
  const [headers, setHeaders] = useState();
  const [Section, setSection] = useState("");
  const [HeaderId, setHeaderId] = useState("");
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const handleApprovalOnClose = () => setShowApprovalModal(false);
  const {metaData}=useFetchMetaData({value:"status_definition"})

  function clearFilter() {
    getData();
    navigate(".", { replace: true, state: { statusFilter: null } });
  }

  async function fetchHeader(section, headerId) {
    await axiosInstance
      .get(
        statusFilter
          ? `/internal-audit/standard/${stdId}/${headerId}/section/${section}/status/${statusFilter}`
          : `/internal-audit/standard/${stdId}/${headerId}/section/${section}`
      )
      .then((res) => {
        res.data?.data && setexpandedRow(res.data?.data);
      });
  }

  const toggle = (i, section, headerId) => {
    if (selected === i) {
      setexpandedRow([]);
      return setSelected(null);
    }
    setexpandedRow([]);
    setSelected(i);
    setSection(section);
    setHeaderId(headerId);
    fetchHeader(section, headerId);
  };

  return (
    <>
      <ViewTableIndex
        label="Internal Audit Checklist"
        menu="Activity"
        standardName={standardName}
        total={totalCount}
        setDataCount={setDataCount}
        dataCount={dataCount}
        pageIndex={pageIndex}
        setPageIndex={setPageIndex}
        setOpenForm={setShowMyModal}
        Access="activity_create"
        hasOverAll={true}
        OverAllPercentage={completePercentage}
        header={header}
        isLoading={isLoading}
        ExportAccess="export"
        ExportFunction={() => setShowExport(true)}
        hasExport={true}
        ImportAccess="import"
        ImportFunction={() => setShowImport(true)}
        hasImport={true}
        hasFilter={true}
        filterValue={statusFilter}
        clearFunction={clearFilter}
        hasApprove={true}
        ReviewStatus={isReveiw}
        ReviewFunction={() => setShowApprovalModal(true)}
      >
        <>
          {data &&
            data.map((i, indx) => {
              return (
                <>
                  <div className="" key={indx}>
                    <div className="pl-5 pr-2 py-2 mt-1.5 bg-tableeven shadow-box flex justify-between items-center">
                      <span
                        className={
                          selected === indx
                            ? "text-xs 2xl:text-sm font-medium text-gray-900 w-full"
                            : "text-xs 2xl:text-sm font-medium text-gray-500 w-[40%]"
                        }
                      >
                        <h2 className="leading-5 ">
                          {/* {i?.value[1]} */}
                          {i?.header_no} &nbsp;
                          {i?.header_title}
                        </h2>
                        <h2 className="leading-5">
                          {/* {i?.value[2]} */}
                          {i?.section_no} &nbsp;
                          {i?.section}
                        </h2>
                      </span>

                      <div className="flex justify-end w-[5%]">
                        <span
                          className="bg-white w-7 h-7 flex items-center justify-center px-[10px] rounded-[3px] shadow-box cursor-pointer"
                          onClick={() =>
                            toggle(
                              indx,
                              i?.section_no,
                              i?.header_id
                              // , i?.value[0], i?.key
                            )
                          }
                        >
                          {selected === indx ? <UpArrow /> : <DownArrow />}
                        </span>
                        {GetAccess("activity_create") && (
                          <span
                            className="w-7 ml-1"
                            onClick={() => {
                              setShowMyMenuModal(true);
                              setHeaders(i);
                            }}
                          >
                            <AddIcon />
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div
                    className={
                      selected === indx
                        ? "tabledescription show mr-1 relative"
                        : "tabledescription mr-1 relative"
                    }
                  >
                    {expandedRow &&
                      expandedRow.map((i) => {
                        return (
                          <tr className="odd:bg-tableodd even:bg-tableeven flex justify-between items-center text-left my-1 text-xs 2xl:text-sm py-2 font-normal">
                            <td className="px-2 xl:px-8 text-gray-900 whitespace-normal w-[7%]">
                              {/* {i?.sectionId} */}
                              {i?.section_no}
                            </td>
                            <td className="px-2 xl:px-8 text-gray-900 whitespace-normal w-[10%]">
                              {/* {i.subSectionId} */}
                              {i?.sub_section_no}
                            </td>
                            <td className="pr-2 text-gray-900 text-justify whitespace-normal w-[45%] break-words">
                              {i.question_activity}
                            </td>
                            <td className="text-gray-900 capitalize whitespace-normal w-[15%]">
                              {i.status}
                            </td>
                            <td className="px-2 xl:px-8 text-gray-900 whitespace-normal w-[7%]">
                              {i.image_path !== null &&
                                i.image_path !== "None" &&
                                i.image_path !== "[]" &&
                                i.image_path.length > 0 && <PaperClip />
                              }
                            </td>
                            <td className=" w-[3%]">
                              <ViewMore
                                data={i}
                                onClose={handleOnCloseMenu}
                                visible={showMyMenuModal}
                                id={stdId}
                                fetcherHeader={()=>fetchHeader(Section,HeaderId)}
                                fetcher={getData}
                                satusData={statusValue}
                                getCompletion={getDashboardData}
                                headerId={headers}
                                internalAuditDefinition={metaData}
                              />
                            </td>
                          </tr>
                        );
                      })}
                  </div>
                </>
              );
            })}
        </>
      </ViewTableIndex>
      <CreateOrEdit
        visible={showMyMenuModal}
        onClose={handleOnCloseMenu}
        refreshData={getData}
        satusData={statusValue}
        getCompletion={getDashboardData}
        headerId={headers}
        id={stdId}
        fetcherHeader={()=>fetchHeader(Section,HeaderId)}
        internalAuditDefinition={metaData}
      />
      <CommonXlsExport
        id={stdId}
        path={`internal_audit`}
        name={`${standardDetailName} Internal Audit Checklist ${
          standardStartDate &&
          NuDateFormat({ value: standardStartDate, format: "MMM-YYYY" })
        } ${standardEndDate && "to"} ${
          standardEndDate &&
          NuDateFormat({ value: standardEndDate, format: "MMM-YYYY" })
        }`}
        visible={showExport}
        onClose={() => {
          setShowExport(false);
        }}
      />

      <CommonImport
        url={`/internal-audit/standard/${stdId}/Import`}
        refreshData={getData}
        getFuction={getDashboardData}
        visible={showImport}
        onClose={() => setShowImport(false)}
        hasRemoveApproval={true}
        moduleId={ModelId}
        standardId={stdId}
      />

      <CommomApproval
        visible={showApprovalModal}
        onClose={handleApprovalOnClose}
        refreshData={getData}
        moduleId={ModelId}
        id={stdId}
        moduleName="Internal Audit Checklist"
        standardName={standardDetailName}
        getCompletion={getDashboardData}
      />
      <CreateForm
        id={stdId}
        refreshData={getData}
        visible={showMyModal}
        onClose={handleOnClose}
      />
    </>
  );
}

export default InternalAuditChecklistIndex;

const header = [
  {
    headone: "Section",
    width: "w-[7%]",
  },
  {
    headone: "Sub - Section",
    width: "w-[10%]",
  },
  {
    headone: "Questions / Activity",
    width: "w-[47%]",
  },
  {
    headone: "Status",
    width: "w-[15%]",
  },
  {
    headone: "Attachment Artefact",
    width: "w-[18%]",
  },
  {
    headone: "",
    width: "w-[3%]",
  },
];
